import React, {  useCallback } from "react";
import {  useSelector } from "react-redux";
import {  Form } from "semantic-ui-react";
import { AddBtn } from "../../../../commonComponents/AddBtn";
import { FormTitle } from "../../../../commonComponents/FormTitle";
import List from "../../../../commonComponents/List";
import { CustomLoader } from "../../../../commonComponents/formComponents/loader";
import PreviousDocumentsDetails from "../../headerTab/previousDocumentsDetails";
import { useDocument } from "../../../hooks/useDocument";
import { useUpdateEffect } from "../../../../hooks/index";
import { selectDeclarationType, selectMrnNo, selectTransmissionTypeVal } from "../../../selectors";
import { SUPDecType } from "../../util";
import { TranslateContext } from "../../TranslateContext";

const PreviousDocuments = ({isImportShipment}) => {
   
  const {isLoading,AddItem,deleteItem,updateItem,saveItem,updateAllItems}=useDocument({actionType:"HEADER",tableName:"prevDoc",containerKey:"header"})
  const previousDocList = useSelector((state) => state.Shipment.prevDoc);
  const declarationEntryType=useSelector((state)=>selectDeclarationType(state))
  const transmissionType=useSelector((state)=>selectTransmissionTypeVal(state))
  const mrn=useSelector((state)=>selectMrnNo(state))

  const translate = React.useContext(TranslateContext).translate
 
  const isUpdateDocRef=React.useMemo(()=>(!isImportShipment && transmissionType=="SUP" && SUPDecType.includes(declarationEntryType)),[isImportShipment,declarationEntryType,transmissionType])
       
    useUpdateEffect(()=>{
  
        if(isUpdateDocRef && previousDocList.length>0){   
        updateAllItems({docRef:mrn})
        const data=previousDocList.filter(c=>c.docRef!=mrn).map((item)=>({docRef:mrn,id:item.id}))
        saveItem(data)
        }
   },[isUpdateDocRef,saveItem])
  
  const renderItem=useCallback((item)=>{
    return  <PreviousDocumentsDetails
    key={item.id}
    item={item}
     updateData={updateItem}
     deleteData={deleteItem}
     saveData={saveItem}
    />
   },[updateItem,deleteItem,saveItem])
  
  
  return (
  
    <Form.Group className="float-container">
      <FormTitle boxNumber={isImportShipment ? "40" : "2/1" } title={isImportShipment ? translate("DOC_PROCEDURE") : translate("PREVIOUS_DOCUMENT", {ns:["default", "header", 'lineItem']})}></FormTitle>
          
        <List 
          dataSource={previousDocList}
          renderItem={renderItem}
        />
  
      { isLoading && <CustomLoader /> }
      {
       previousDocList?.length<99 && <AddBtn  onClick={()=>AddItem((response)=>{
        isUpdateDocRef && updateItem(response.responseMessage,{docRef:mrn})
        isUpdateDocRef && saveItem({id:response.responseMessage,docRef:mrn})
       })} text={translate("ADD")}>

      </AddBtn>
}
      </Form.Group>
   
  );
}

export default React.memo(PreviousDocuments)
